import { createSelector } from 'reselect';

export const getWidgetData = (state, widgetId) =>
    state.dashboardWidgets?.widgetsData?.[widgetId]?.data || {};

export const getWidgetDataFetching = (state, widgetId) =>
    state.dashboardWidgets?.widgetsData?.[widgetId]?.fetching || false;

export default createSelector([getWidgetData, getWidgetDataFetching]);
